import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
const utility = tokens.componentColors.utility;

export const boardHeaderStyleId = 'wb-v2-board-header-theme';

export const boardHeaderBridgeStyles = {
  'board-header': {
    '--local-board-header-title-badge-bg': utility.brand50,
    '--local-board-header-title-badge-color': utility.brand700,
    '--local-board-header-title-badge-border': utility.brand200,
    '--local-board-header-title-badge-margin-left': tokens.spacing.md,
    '--local-board-header-padding-block': tokens.spacing.lg,
    '--local-board-header-padding-inline': tokens.spacing.xl,
    '--local-board-header-filter-padding-block': tokens.spacing.md,
    '--local-board-header-paging-padding-block': tokens.spacing.xs,
    '--local-board-header-paging-padding-inline': tokens.spacing.xl,
    '--local-board-header-countless-gap': tokens.spacing.sm,
    '--local-board-header-countless-text': tokens.color.text.secondary,
    '--local-board-header-countless-font-family': tokens.font.family.body,
    '--local-board-header-countless-font-size': tokens.font.size.textSm,
    '--local-board-header-countless-font-weight': tokens.font.weight.medium,

    '--local-board-header-refresh-container-bg': tokens.color.background.primary,
    '--local-board-header-refresh-bg': tokens.color.background.secondarySubtle,
    '--local-board-header-refresh-border': tokens.color.border.brand,
    '--local-board-header-refresh-text': tokens.color.text.brandSecondary,
    '--local-board-header-refresh-button-bg': tokens.color.background.brandSolid,
    '--local-board-header-refresh-button-text': tokens.color.text.white,
    '--local-board-header-refresh-focus': tokens.color.border.brand,
    '--local-board-header-refresh-padding-x': tokens.spacing.lg,
    '--local-board-header-refresh-padding-y': tokens.spacing.md,
    '--local-board-header-refresh-outer-padding-x': tokens.spacing.lg,
    '--local-board-header-refresh-gap': tokens.spacing.md,
    '--local-board-header-refresh-border-width': tokens.borderWidth.sm,
    '--local-board-header-refresh-button-padding-x': tokens.spacing.lg,
    '--local-board-header-refresh-button-padding-y': tokens.spacing.sm,
    '--local-board-header-refresh-button-radius': tokens.radius.sm,
    '--local-board-header-refresh-focus-width': tokens.borderWidth.md,
    '--local-board-header-refresh-focus-offset': tokens.spacing.xxs,
    '--local-board-header-refresh-font-family': tokens.font.family.body,
    '--local-board-header-refresh-font-size': tokens.font.size.textSm,
    '--local-board-header-refresh-font-weight': tokens.font.weight.medium,
    '--local-board-header-refresh-button-font-weight': tokens.font.weight.semibold,

    '--local-board-header-compact-padding-x': tokens.spacing.lg,
    '--local-board-header-compact-padding-y': tokens.spacing.md,
    '--local-board-header-narrow-padding-x': tokens.spacing.md,
    '--local-board-header-compact-gap': tokens.spacing.md,
    '--local-board-header-compact-search-width': '180px',
    '--local-board-header-view-max-width': '240px',
  },
  'board-header.is-narrow': {
    '--local-board-header-view-max-width': '160px',
  },
  '.cdk-overlay-container .board-filters-overlay': {
    '--local-board-filter-panel-bg': tokens.color.background.primary,
    '--local-board-filter-panel-border': tokens.color.border.secondary,
    '--local-board-filter-panel-text': tokens.color.text.primary,
    '--local-board-filter-panel-radius': tokens.radius.lg,
    '--local-board-filter-panel-padding': tokens.spacing.lg,
    '--local-board-filter-panel-gap': tokens.spacing.lg,
    '--local-board-filter-row-gap': tokens.spacing.md,
    '--local-board-filter-panel-title-size': tokens.font.size.textSm,
    '--local-board-filter-panel-title-line-height': tokens.lineHeight.textSm,
    '--local-board-filter-panel-title-weight': tokens.font.weight.semibold,
    '--local-board-filter-panel-width': '320px',
    '--local-board-filter-panel-max-height': 'min(70vh, 560px)',
    '--local-board-filter-panel-focus': tokens.color.border.brand,
  },
};
